import React from 'react';
import { motion } from 'framer-motion';
import { Wave, Palm, Mountain } from './graphics/Glyphs';
const locations = [{
  name: 'Costa Rica',
  region: 'Pacific Coast',
  tagline: 'Surf. Jungle. Pacific light.',
  Glyph: Palm
}, {
  name: 'Mexico',
  region: 'Oaxaca · Tulum',
  tagline: 'Color. Craft. Coastline.',
  Glyph: Wave
}, {
  name: 'Portugal',
  region: 'Comporta · Algarve',
  tagline: 'Atlantic light. Slow days.',
  Glyph: Mountain
}];
export function Locations() {
  return <section id="locations" className="bg-bone py-24 md:py-32 px-6 md:px-12" data-id="element-151">
      <div className="max-w-5xl mx-auto" data-id="element-152">
        <div className="text-center mb-16" data-id="element-153">
          <p className="eyebrow mb-6" data-id="element-154">Launching 2027</p>
          <motion.h2 initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="font-serif-display text-3xl md:text-5xl text-ink leading-[1.1]" data-id="element-155">
            Three houses. <span className="italic" data-id="element-156">A beginning.</span>
          </motion.h2>
        </div>

        <div className="border-t border-ink/10" data-id="element-157">
          {locations.map((l, i) => {
          const Glyph = l.Glyph;
          return <motion.div key={l.name} initial={{
            opacity: 0,
            y: 8
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.6,
            delay: i * 0.1
          }} className="grid grid-cols-12 gap-4 py-8 md:py-10 border-b border-ink/10 items-center group" data-id="element-158">
                <div className="col-span-2 md:col-span-1 text-ink/60 group-hover:text-sun transition-colors duration-500" data-id="element-159">
                  <Glyph className="w-8 h-8 md:w-10 md:h-10" data-id="element-160" />
                </div>
                <h3 className="col-span-10 md:col-span-5 font-serif-display text-3xl md:text-4xl text-ink" data-id="element-161">
                  {l.name}
                </h3>
                <p className="hidden md:block md:col-span-4 font-serif-display italic text-ink/55 text-base" data-id="element-162">
                  {l.tagline}
                </p>
                <p className="col-span-12 md:col-span-2 eyebrow !text-muted md:text-right" data-id="element-163">
                  {l.region}
                </p>
              </motion.div>;
        })}
        </div>

        <p className="mt-12 text-center font-serif-display italic text-ink/40 text-base" data-id="element-164">
          More houses opening soon — Argentina, Chile & beyond.
        </p>
      </div>
    </section>;
}